import styled from 'styled-components'

export const Component = styled.div`
  position: absolute;
  left: 350px;
  background-color: #414B56;
  width: calc(100vw - 350px);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`